<template>
    <div>
        <button @click="showModal = true" class="button-brekz button-brekz--rounded button-brekz--green button-brekz--lg">
            <slot></slot>
        </button>

        <modal-vue title="Wilt u uw bestelling kunnen volgen?" :rounded-top="true" :hide-nav="true" :useModalTemplate="false" :show="showModal" :cancel-if-clicked-outside-modal="false" width="sm">
            <div class="guest-to-customer__header d-flex">
                <p class="my-3">{{ $t('orderConfirmation.modalTitle')}}</p>
                <i @click="showModal = false" class="fas fa-times my-auto ml-auto cursor-pointer"></i>
            </div>

            <div class="px-3 py-4">
                <p v-html="$t('orderConfirmation.modalMessage')"></p>

                <div class="d-flex flex-wrap">
                    {{ $t('orderConfirmation.enterPassword')}}
                    <span class="ml-auto mt-auto text--sm text--gray">{{ $t('orderConfirmation.minimumWarning')}}</span>
                </div>

                <div class="guest-to-customer-input" :class="{ 'mb-2': !(hasError && !isSubmitting) }">
                    <input :type="showPassword ? 'text' : 'password'" class="input py-1" :class="{ 'guest-to-customer-input--error': hasError && !isSubmitting && isUserError }" v-model="password" minlength="5">
                    <div @click="showPassword = !showPassword" class="guest-to-customer-input__icon">
                        <i v-if="!showPassword" class="fa fa-eye" aria-hidden="true"></i>
                        <i v-else class="fa fa-lock" aria-hidden="true"></i>
                    </div>
                </div>
                <small
                    v-if="hasError && !isSubmitting"
                    class="text-danger mb-2"
                >
                    {{ isUserError ? $t('orderConfirmation.passwordTooShort') : $t('orderConfirmation.somethingWentWrong') }}
                </small>
            </div>

            <div class="guest-to-customer__bottom py-4">
                <button
                    :disabled="isSubmitting"
                    @click="transformGuest()"
                    class="button-brekz button-brekz--rounded button-brekz--xl mx-auto button-brekz--green"
                >
                    OK
                </button>
            </div>
        </modal-vue>
    </div>
</template>

<script>
export default {
    name: "GuestToCustomerModal",
    props: {
        idOrder: {
            type: Number,
            required: true
        },
        emailAddress: {
            type: String,
            required: true
        },
        transformToken: {
            type: String,
            required: true
        },
        submitUrl: {
            type: String,
            required: true
        },
        redirectUrl: {
            type: String,
            required: true
        },
        authenticateUrl: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            password: '',
            showPassword: false,
            showModal: false,
            hasError: false,
            isUserError: false,
            isSubmitting: false,
        }
    },
    methods: {
        transformGuest() {
            this.isSubmitting = true;

            jQuery.ajax(this.submitUrl, {
                type: "POST",
                data: {
                    id_order: this.idOrder,
                    transform_token: this.transformToken,
                    password: this.password
                },
                success: response => {
                    this.attemptLogin();
                },
                error: XMLHttpRequest => {
                    this.isSubmitting = false;
                    this.hasError     = true;

                    this.isUserError = XMLHttpRequest.status === 400;
                }
            });
        },
        attemptLogin() {
            jQuery.ajax(this.authenticateUrl, {
                type: "POST",
                data: {
                    email: this.emailAddress,
                    passwd: this.password,
                    ajax: true,
                    SubmitLogin: true
                },
                success: response => {
                    const data = JSON.parse(response);

                    if (data.hasError) {
                        window.location.href = this.authenticateUrl;

                        return;
                    }

                    window.location.href = this.redirectUrl;
                },
                error: XMLHttpRequest => {
                    window.location.href = this.authenticateUrl;
                }
            });
        }
    }
}
</script>

<style lang="scss">
    .guest-to-customer {
        &__header {
            border-bottom: 2px solid #C8E1C8;
        }
        &__bottom {
            display: flex;
            border-top: 2px solid #C8E1C8;
        }
        &-input {
            position: relative;

            &__icon {
                cursor: pointer;
                position: absolute;
                right: 10px;
                top: 5px;
            }

            &--error {
                border: 1px red solid;
            }
        }
    }
</style>
